import { render, staticRenderFns } from "./FacturacionGlobal.vue?vue&type=template&id=4f57ca24&"
import script from "./FacturacionGlobal.vue?vue&type=script&lang=js&"
export * from "./FacturacionGlobal.vue?vue&type=script&lang=js&"
import style0 from "./FacturacionGlobal.vue?vue&type=style&index=0&id=4f57ca24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports